function SocialGlassPills({ title, choosenPill, setChoosenPill }) {
  return (
    <div
      className={`cursor-pointer text-pretty rounded-full px-3 py-2 text-lg transition-all duration-500 ${
        choosenPill === title
          ? "bg-[#FAD8DA] text-red-500"
          : "bg-white text-black hover:bg-[#FAD8DA] hover:text-red-500"
      }`}
      onClick={() => setChoosenPill(title)}
    >
      {title}
    </div>
  );
}

export default SocialGlassPills;
